import React from 'react'
import {reportApi} from "./reportApi";
import type { ContextProps } from '../../types';
import {PageTitle} from '../../Components/Landmarks';
import {ReportsFormView} from './ReportsFormView';
import {InputForm, useInputForm} from '../../Components/Inputs';
import {reportsDetailsModel} from './reportsDetailsFactory';
import {LayoutSmall} from "../../Components/Layout";
import {isNullOrUndefined} from "../../Utilities/commonUtilities";
import {REPORT_TYPES} from "./reportsConstants";


export const ReportsContainer = ({
                                     districts,
                                     handleApiCall,
                                 }: ContextProps) => {

    const reportForm = useInputForm(reportsDetailsModel());

    const handleExportReport = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        const reportSearchCriteria = {
            reportType: reportForm.reportType.value,
            startDate: reportForm.startDate.value,
            endDate: reportForm.endDate.value,
            districtId: reportForm.reportType.value === REPORT_TYPES.OrdersCompleted? reportForm.districtId.value : ``
        };

        handleApiCall(() => reportApi.exportReport(reportSearchCriteria));
    };

    if (isNullOrUndefined(districts) || districts.length === 0) return;

    return <>
        <LayoutSmall>
            <PageTitle h1={`Reports`}/>
            <InputForm name={"Reports"}>
                <ReportsFormView
                    districts={districts}
                    handleExportReport={handleExportReport}
                    reportForm={reportForm}
                />
            </InputForm>
        </LayoutSmall>
        <br/>
        <br/>
        <br/>

    </>
}

